<template lang="pug">
div.wrap-atom-hair-wind-changer
  //- div(@click="showController = !showController").f.fm.flex-between.pb12.cursor-pointer  
    div.f.fm
      span.label.block.fz16 風
    v-icon(dark) {{showController ? 'mdi-chevron-up' : 'mdi-chevron-down'}}
  v-checkbox(v-model="hasHairWind" dark
    @change="onChangeHasHairWind"
    label="風" append-icon="mdi-weather-windy")

  div(v-if="hasHairWind")
    span.label.block.fz14 風力:
    v-slider(v-model="windParams.force"
      min="0.0" max="5.0" :step="step"
      dark)

    span.label.block.fz14 風向:
    v-slider(v-model="windParams.vec.x" label="x"
      min="-1.0" max="1.0" :step="step"
      color="red" dark)
    v-slider(v-model="windParams.vec.y" label="y"
      min="-1.0" max="1.0" :step="step"
      color="green" dark)
    v-slider(v-model="windParams.vec.z" label="z"
      min="-1.0" max="1.0" :step="step"
      color="blue" dark)

    span.label.block.fz14 回転:
    v-slider(v-model="windParams.euler.x" label="x"
      min="-0.1" max="0.1" :step="step"
      color="red" dark)
    v-slider(v-model="windParams.euler.y" label="y"
      min="-0.1" max="0.1" :step="step"
      color="green" dark)
    v-slider(v-model="windParams.euler.z" label="z"
      min="-0.1" max="0.1" :step="step"
      color="blue" dark)
    
    div.f.flex-right.pb16
      span(@click="onReset").btn-rest.fz14.cursor-pointer リセット
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-atom-hair-wind-changer {
  color: $dark_primary_text_color;
  .btn-rest {
    color: $active_color;
  }
}
</style>

<script>
import studioManager from '@/components/mixin/studioManager'
// import vrmManager from '@/components/mixin/vrmManager'

export default {
  mixins: [studioManager],
  props: {
    targetObject: {
      type: Object,
      required: true
    },
    targetObjectDoc: {
      type: Object,
      default: null
    },
    clock: {
      type: Object,
      required: true
    },
    isPhotoStudio: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      windParams: {
        vec: { x: 0, y: 0, z: 0 },
        euler: { x: 0, y: 0, z: 0 },
        force: 0
      },
      step: 0.01,
      hasHairWind: false,
      preventUpdateDocField: false,
      saveTimer: null
    }
  },
  computed: {
    vrm () {
      return this.targetObject.userData.vrm
    }
  },
  watch: {
    windParams: {
      handler () {
        this.updateHairWindProp(this.windParams)
      },
      deep: true
    }
  },
  created () {
    if (this.targetObjectDoc && !this.isPhotoStudio) {
      if (this.targetObjectDoc.hairWind) {
        this.windParams = this.targetObjectDoc.hairWind
        this.hasHairWind = true
      }
    }
  },
  methods: {
    async onChangeHasHairWind () {
      if (this.hasHairWind) {
        this.saveHariWindParams()
      } else {
        // watchでfieldがセーブされないようにする
        this.preventUpdateDocField = true
        this.onReset()
        await this.sleep(400)
        this.$emit('deleteObjectDocField', {
          docId: this.targetObject.userData.docId,
          fieldName: 'hairWind'
        })
      }
    },
    updateHairWindProp (windParams) {
      // console.log('updateHairWindProp', { ...windParams })
      const params = {
        vec: this.toVector3(windParams.vec), // new THREE.Vector3(0.5, -1, 0),
        euler: this.toEuler3XYZ(windParams.euler), // new THREE.Euler(0, 0, 0, 'XYZ'),
        windForce: windParams.force
      }
      this.$emit('updateHairWind', {
        vrm: this.vrm,
        delta: this.clock.getDelta(),
        params
      })
      // photo studioの場合は保存しない
      if (!this.isPhotoStudio && !this.preventUpdateDocField) {
        clearTimeout(this.saveTimer)
        this.saveTimer = setTimeout(this.saveHariWindParams, 2000)
      } else {
        this.preventUpdateDocField = false
      }
    },
    saveHariWindParams () {
      // console.log('saveHariWindParams')
      this.$emit('updateObjectDoc', {
        docId: this.targetObject.userData.docId,
        fieldName: 'hairWind',
        fieldValue: this.windParams
      })
    },
    onReset () {
      this.windParams = {
        vec: { x: 0, y: 0, z: 0 },
        euler: { x: 0, y: 0, z: 0 },
        force: 0
      }
      this.$emit('resetHairWind', {
        vrm: this.vrm,
        delta: this.clock.getDelta()
      })
    }
  }
}
</script>
